import { type PostNordValidatePostalCodeResponseItem } from 'ecosystem'

/**
 * Converts PostNord postal code pattern(s) into a combined RegExp.
 * - A = letter (A-Z)
 * - N = digit (0-9)
 * - ? = letter or digit
 * Accepts multiple patterns and returns a single regex that matches any of them.
 */
export function convertPostNordPatternsToRegExp(
  patterns: PostNordValidatePostalCodeResponseItem['postalCodePattern']
): RegExp {
  const transformedPatterns = patterns.map((pattern) =>
    pattern
      .split('')
      .map((char) => {
        if (char === 'A') return '[A-Z]'
        if (char === 'N') return '\\d'
        if (char === '?') return '[A-Z\\d]'
        return char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      })
      .join('\\s*')
  )

  const combined = transformedPatterns.join('|')
  return new RegExp(`^(${combined})$`)
}
